<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Book-Title--Front-Matter- ">Downward to the Earth</p>
<p class="ORIM-Author-Name--Front-Matter-">Robert Silverberg</p>
<div class="img_container1"> <img alt="image" src="image/logo.jpg"/> </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?70b7270d